import { render, staticRenderFns } from "./Texts.vue?vue&type=template&id=03409ae6"
import script from "./Texts.vue?vue&type=script&lang=js"
export * from "./Texts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports